import { render } from "./Boxes.vue?vue&type=template&id=a4bf6d38&scoped=true"
import script from "./Boxes.vue?vue&type=script&lang=js"
export * from "./Boxes.vue?vue&type=script&lang=js"

import "./Boxes.vue?vue&type=style&index=0&id=a4bf6d38&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4bf6d38"]])

export default __exports__